import { render, staticRenderFns } from "./take-photos.vue?vue&type=template&id=c8000c16&scoped=true&"
import script from "./take-photos.vue?vue&type=script&lang=ts&"
export * from "./take-photos.vue?vue&type=script&lang=ts&"
import style0 from "./take-photos.vue?vue&type=style&index=0&id=c8000c16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8000c16",
  null
  
)

export default component.exports